import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface IDriverTree {
  filterOptions: IFilterOptions;
  selectedDrivers: string[];
  setSelectedDrivers: (items: string[]) => void;
}

const DriverTree = ({ filterOptions, selectedDrivers, setSelectedDrivers }: IDriverTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatDrivers =
    filterOptions?.drivers.map((driver) => ({
      id: driver.id,
      name: driver.label,
      type: "driver",
    })) || [];

  const filteredDrivers = formatDrivers.filter((driver) =>
    get(driver, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectDriver = ({ items }: SelectionChangeResponse) => setSelectedDrivers(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredDrivers}
      selectedItems={selectedDrivers}
      onSelectionChange={handleSelectDriver}
      hasMultiselect={!isEmpty(filteredDrivers)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-driver" value={filteredDrivers.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em motorista" onChange={handleUpdateSearch} />}
    />
  );
};

export default DriverTree;
